export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      products: 'Products',
      contact: 'Contact',
      fpc: 'FPC',
      export: 'Export',
      mushroom: 'Mushroom Unit'
    },

    // Hero Section
    hero: {
      title: 'Kanhaiya Krushi Seva Kendra',
      subtitle: 'Your Trusted Partner for Better Farming',
      description:
        'Scientific soil testing, genuine agricultural inputs, and expert farm advice—all under one roof. Because your farm deserves the best.',
      cta: 'Know Our Services',
      location: 'Proudly serving farmers of Jeur, Karmala Taluka, and surrounding villages'
    },

    // Services
    services: {
      title: 'What We Do for You',
      subtitle: 'Complete Support from Soil to Sale',
      soilTesting: {
        title: 'Soil Testing',
        description:
          'Get your soil tested in our lab. Know exactly what your soil needs—nitrogen, phosphorus, potash, and micronutrients. Tailored recommendations for your crop and field.'
      },
      fertilizers: {
        title: 'Quality Farm Inputs',
        description:
          'Genuine fertilizers, certified seeds, and effective pesticides—only from trusted, authorized brands. No fake products, no cheating.'
      },
      farmVisits: {
        title: 'Expert Farm Visits',
        description:
          'Our agricultural experts visit your farm, understand your problems, and give practical solutions—from sowing to harvest.'
      },
      marketing: {
        title: 'Market Support',
        description:
          'We help connect you with good buyers. Get fair prices for your produce without middlemen eating your profit.'
      },
      bookService: 'Book Service',
      learnMore: 'Learn More'
    },

    // About
    about: {
      title: 'About Kanhaiya Krushi',
      mainTitle: 'Working for Farmers Since Day One',
      description:
        'Kanhaiya Krushi Seva Kendra, located at Jeur in Karmala Taluka, is dedicated to improving farming and farmer income in Solapur District. We provide soil testing, quality inputs, technical advice, and market linkage—everything a farmer needs to succeed.',
      mission: 'Our Mission',
      missionText:
        'To help farmers increase their income through scientific farming, reliable inputs, and better market access.',
      vision: 'Our Vision',
      visionText:
        'To become the most trusted agricultural service center in Solapur District—and expand across Maharashtra through Farmer Producer Companies.',
      currentOperations: 'What We Offer at Jeur',
      operation1: 'Full-service agricultural center at one place',
      operation2:
        'Soil testing lab with NPK and micronutrient analysis',
      operation3:
        'Authorized dealer for quality fertilizers, seeds, and crop protection',
      operation4: 'On-farm expert advice and crop management guidance',
      operation5:
        'Market price information and buyer connections',
      futureExpansion: 'Future Plans',
      future1: 'Starting a Farmer Producer Company (FPC) for collective strength',
      future2: 'Export support for local agricultural produce',
      future3: 'Opening more service centers across Solapur District',
      future4: 'Digital platform for real-time advice and market updates'
    },

    // Products
    products: {
      title: 'Agricultural Products',
      subtitle: 'Quality Products for Better Yields',
      category: {
        all: 'All Products',
        fertilizers: 'Fertilizers',
        seeds: 'Seeds',
        pesticides: 'Pesticides',
        equipment: 'Equipment',
        other: 'Other'
      },
      inStock: 'Available',
      outOfStock: 'Not Available',
      inquire: 'Ask About This',
      viewDetails: 'See Details'
    },

    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'We Are Here to Help You',
      getInTouch: 'Talk to Our Team',
      description:
        'Have a question about crops, inputs, or services? Send us a message. Our experts will help you.',
      form: {
        name: 'Your Name',
        email: 'Email (Optional)',
        phone: 'Mobile Number',
        subject: 'What do you need?',
        message: 'Your Question / Message',
        service: 'Which service are you interested in?',
        selectService: 'Choose a service',
        submit: 'Submit',
        sending: 'Sending...'
      },
      info: {
        title: 'Our Address',
        address: 'Location',
        addressValue:
          'Kanhaiya Krushi Seva Kendra, Jeur, Tal. Karmala, Dist. Solapur, Maharashtra',
        phone: 'Phone',
        email: 'Email',
        hours: 'Open Hours',
        hoursValue:
          'Monday to Sunday: 9:00 AM – 6:00 PM (Open every day)'
      },
      success: 'Thank you! We will call you within 24 hours.',
      error:
        'Could not submit. Please call us directly or try again.'
    },

    // FPC (Future)
    fpc: {
      title: 'Farmer Producer Company',
      comingSoon: 'Coming Soon',
      description:
        'We are forming a Farmer Producer Company (FPC) where farmers can buy inputs together at lower prices, sell produce together for better prices, and share profits from value addition.',
      benefits: 'Benefits for Member Farmers',
      benefit1: 'Better prices by selling together',
      benefit2: 'Lower input costs through bulk buying',
      benefit3: 'Professional management and transparent operations',
      benefit4: 'Share in company profits based on your business',
      register: 'Register Your Interest',
      registerDesc:
        'Want to become a founding member? Register early.'
    },

    // Export (Future)
    export: {
      title: 'Export Services',
      comingSoon: 'Planned for Future',
      description:
        'We plan to help farmers export quality produce to international markets—meeting global standards and getting premium prices.',
      features: 'What We Will Offer',
      feature1: 'Connect with international buyers',
      feature2: 'Help with export paperwork and compliance',
      feature3: 'Quality certification and tracking',
      feature4: 'Logistics and supply chain support'
    },

    // Mushroom Project
    mushroom: {
      badge: 'Upcoming Project',
      heroTitle: 'Mushroom Production Unit',
      heroSubtitle: 'Kanhaiya Krushi is setting up a commercial oyster mushroom production and processing unit — a sustainable, high-value agribusiness starting soon.',
      location: 'Gat No. 373, Shetphal, Taluka Karmala, District Solapur, Maharashtra',

      overviewTitle: 'About This Project',
      overviewDesc: 'This upcoming unit will produce fresh oyster mushrooms and value-added products like dried mushrooms and mushroom powder. The project uses locally available agro-waste (paddy straw, wheat straw) as raw material — making it sustainable and cost-effective. The unit is supported under the Maharashtra MAHADBT Horticulture Scheme.',

      stat1Label: 'Bags per Cycle',
      stat1Value: '1,500',
      stat2Label: 'Annual Fresh Output',
      stat2Value: '18.2 Tons',
      stat3Label: 'Annual Cycles',
      stat3Value: '11',
      stat4Label: 'Expected Annual Revenue',
      stat4Value: '₹22.97 L',

      productsTitle: 'Products from This Unit',
      productsSubtitle: 'Three product lines — fresh, dried, and powdered — targeting different markets.',
      prod1Title: 'Fresh Oyster Mushroom',
      prod1Desc: 'Supplied fresh to hotels, restaurants, hostels, and local markets. Harvested hygienically and delivered same day.',
      prod1Price: 'Wholesale: ₹100–120/kg',
      prod2Title: 'Dried Mushroom',
      prod2Desc: 'Sun or drum dried to 8% moisture. Long shelf life, retail-ready packs in 100g, 250g, 500g sizes.',
      prod2Price: 'Retail: ₹800–1,200/kg',
      prod3Title: 'Mushroom Powder',
      prod3Desc: 'Fine powder from dried mushrooms. Used in cooking, health supplements, and nutrition products.',
      prod3Price: 'Retail: ₹400–600/kg',

      whyTitle: 'Why Oyster Mushroom?',
      why1: 'Fast growing — harvest ready in 35–40 days per crop cycle',
      why2: 'Thrives in Maharashtra climate (20–30°C) — no heavy cooling needed',
      why3: 'Uses cheap agro-waste as substrate — low raw material cost',
      why4: 'Strong market demand — 15–20% annual growth in India',
      why5: 'Multiple revenue streams — fresh, dried, powder',
      why6: 'Eligible for 40% government subsidy under MAHADBT scheme',

      infraTitle: 'Infrastructure & Setup',
      infraSubtitle: 'The unit will have a complete integrated production facility.',
      infra1: 'Mushroom Shed (1,200–1,400 sq.ft.)',
      infra2: 'Incubation & Fruiting Zones',
      infra3: 'Pasteurization Drum & Boiler',
      infra4: 'Drum / Solar Dryer',
      infra5: 'Production Racks & Storage',
      infra6: 'Office, Toilet & Utilities',

      finTitle: 'Financial Highlights',
      finCol1: 'Parameter',
      finCol2: 'Value',
      fin1L: 'Total Project Cost',
      fin1V: '₹29.80 Lakhs',
      fin2L: 'Bank Term Loan',
      fin2V: '₹14.00 Lakhs',
      fin3L: 'MAHADBT Subsidy (40%)',
      fin3V: '₹11.92 Lakhs',
      fin4L: 'Expected Annual Revenue (Year 1)',
      fin4V: '₹22.97 Lakhs',
      fin5L: 'EBITDA (Year 1)',
      fin5V: '₹7.74 Lakhs',
      fin6L: 'Payback Period',
      fin6V: 'Within 2–3 months of Year 1',

      timelineTitle: 'Project Timeline',
      timelineSubtitle: 'Expected to complete and begin commercial production in 8.5–10 months from loan disbursement.',
      phase1: 'Site Preparation',
      phase1Desc: 'Site clearance, permits, vendor selection, design finalization.',
      phase1Months: 'Month 1–2',
      phase2: 'Construction & Equipment',
      phase2Desc: 'Shed construction, electrical, water fittings, all equipment installation.',
      phase2Months: 'Month 3–7.5',
      phase3: 'Commercial Production',
      phase3Desc: 'Trial batch, first harvest, market launch — full production begins.',
      phase3Months: 'Month 8.5 onwards',

      ctaTitle: 'Interested in Buying or Partnering?',
      ctaDesc: 'If you are a hotel, restaurant, retailer, or distributor — contact us to pre-register your interest for supply.',
      ctaBtn: 'Contact Us'
    },

    // Footer
    footer: {
      about: 'About Us',
      aboutText:
        'Kanhaiya Krushi Seva Kendra at Jeur, Karmala Taluka—your one-stop partner for all farming needs in Solapur District.',
      quickLinks: 'Quick Links',
      services: 'Services',
      contactUs: 'Contact',
      followUs: 'Follow Us',
      copyright: '© 2025 Kanhaiya Krushi Seva Kendra. All rights reserved.',
      developedBy: 'Serving the farmers of Solapur District with pride'
    },

    // Common
    common: {
      readMore: 'Read More',
      close: 'Close',
      submit: 'Submit',
      cancel: 'Cancel',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      loading: 'Loading...',
      error: 'Error occurred',
      success: 'Success!',
      required: 'Required field'
    }
  },

  mr: {
    // Navigation
    nav: {
      home: 'होम',
      about: 'आमच्याबद्दल',
      services: 'सेवा',
      products: 'उत्पादने',
      contact: 'संपर्क',
      fpc: 'शेतकरी कंपनी',
      export: 'एक्सपोर्ट',
      mushroom: 'मशरूम युनिट'
    },

    // Hero Section
    hero: {
      title: 'कन्हैया कृषी सेवा केंद्र',
      subtitle: 'तुमच्या शेतीचा खरा साथीदार',
      description:
        'माती टेस्टिंग, खऱ्या खतांची दुकान आणि तज्ञांचा सल्ला—सगळं येथेच. तुमच्या शेतीसाठी फक्त सर्वोत्तम!',
      cta: 'सेवा बघा',
      location:
        'जेऊर, करमाळा तालुका आणि आजूबाजूच्या गावांमध्ये सेवा'
    },

    // Services
    services: {
      title: 'आमच्या सेवा',
      subtitle: 'शेतीपासून बाजारापर्यंत तुमच्या सोबत',
      soilTesting: {
        title: 'माती टेस्टिंग',
        description:
          'आमच्या लॅबमध्ये माती तपासा. तुमच्या मातीला नेमकं काय हवंय ते कळेल—नायट्रोजन, फॉस्फरस, पोटॅश आणि मायक्रो न्यूट्रिएंट्स. तुमच्या पिकासाठी काय घालायचं, किती घालायचं—सगळं आम्ही सांगू.'
      },
      fertilizers: {
        title: 'दर्जेदार शेती साहित्य',
        description:
          'खरी खतं, सर्टिफाईड बियाणं आणि चांगली कीटकनाशकं—फक्त ऑथराईझ्ड कंपन्यांचा माल. खोटा माल नाही, मिलावट नाही, फसवणूक नाही.'
      },
      farmVisits: {
        title: 'तज्ञांची शेत भेट',
        description:
          'आमचे एक्सपर्ट तुमच्या शेतावर येतात, समस्या बघतात आणि सोपे उपाय देतात—पेरणीपासून कापणीपर्यंत मदत.'
      },
      marketing: {
        title: 'मार्केट मदत',
        description:
          'चांगल्या खरेदीदारांशी कनेक्ट करतो. तुमच्या मालाला योग्य रेट मिळो, दलालांकडे नफा जाऊ नये.'
      },
      bookService: 'सेवा घ्या',
      learnMore: 'अधिक माहिती'
    },

    // About
    about: {
      title: 'कन्हैया कृषीबद्दल',
      mainTitle: 'शेतकऱ्यांसाठी, शेतकऱ्यांसोबत',
      description:
        'कन्हैया कृषी सेवा केंद्र, जेऊर (करमाळा तालुका) येथे स्थित आहे. आम्ही सोलापूर जिल्ह्यातील शेतकऱ्यांचं उत्पन्न वाढवण्यासाठी काम करतो. माती टेस्टिंग, दर्जेदार शेती माल, तांत्रिक सल्ला आणि मार्केट कनेक्शन—शेतकऱ्याला यशस्वी होण्यासाठी लागणारं सगळं आमच्याकडे.',
      mission: 'आमचं ध्येय',
      missionText:
        'वैज्ञानिक पद्धतीने शेती, विश्वासू माल आणि चांगला बाजारभाव देऊन शेतकऱ्यांचं उत्पन्न वाढवायचं.',
      vision: 'आमची दृष्टी',
      visionText:
        'सोलापूर जिल्ह्यातील सर्वात विश्वासू शेती सेवा केंद्र बनायचं—आणि एफपीसी मार्फत संपूर्ण महाराष्ट्रात वाढायचं.',
      currentOperations: 'जेऊर येथे आम्ही काय देतो',
      operation1: 'एकाच ठिकाणी संपूर्ण शेती सेवा केंद्र',
      operation2:
        'NPK आणि मायक्रो न्यूट्रिएंट्स टेस्टिंगसाठी माती लॅब',
      operation3:
        'ऑथराईझ्ड खतं, बियाणं आणि कीटकनाशकांची दुकान',
      operation4:
        'शेतावर तज्ञ सल्ला आणि पीक मार्गदर्शन',
      operation5:
        'मार्केट रेट माहिती आणि खरेदीदार कनेक्शन',
      futureExpansion: 'भविष्यातील योजना',
      future1:
        'शेतकरी उत्पादक कंपनी (एफपीसी) सुरू करायची',
      future2: 'स्थानिक उत्पादनांसाठी एक्सपोर्ट मदत',
      future3: 'सोलापूर जिल्ह्यात अधिक सेंटर्स',
      future4:
        'मोबाईल ॲपवर सल्ला आणि मार्केट रेट'
    },

    // Products
    products: {
      title: 'शेती उत्पादने',
      subtitle: 'चांगल्या उत्पन्नासाठी दर्जेदार उत्पादने',
      category: {
        all: 'सर्व उत्पादने',
        fertilizers: 'खतं',
        seeds: 'बियाणं',
        pesticides: 'कीटकनाशकं',
        equipment: 'उपकरणं',
        other: 'इतर'
      },
      inStock: 'उपलब्ध आहे',
      outOfStock: 'उपलब्ध नाही',
      inquire: 'याबद्दल विचारा',
      viewDetails: 'तपशील पहा'
    },

    // Contact
    contact: {
      title: 'संपर्क साधा',
      subtitle: 'आम्ही तुमच्या मदतीला तयार',
      getInTouch: 'आमच्याशी बोला',
      description:
        'पीक, माल किंवा सेवांबद्दल प्रश्न आहे का? मेसेज पाठवा. आमचे तज्ञ मदत करतील.',
      form: {
        name: 'तुमचं नाव',
        email: 'ईमेल (optional)',
        phone: 'मोबाईल नंबर',
        subject: 'तुम्हाला काय हवंय?',
        message: 'तुमचा प्रश्न / मेसेज',
        service: 'कोणती सेवा हवी आहे?',
        selectService: 'सेवा निवडा',
        submit: 'पाठवा',
        sending: 'पाठवतोय...'
      },
      info: {
        title: 'आमचा पत्ता',
        address: 'ठिकाण',
        addressValue:
          'कन्हैया कृषी सेवा केंद्र, जेऊर, ता. करमाळा, जि. सोलापूर, महाराष्ट्र',
        phone: 'फोन',
        email: 'ईमेल',
        hours: 'वेळ',
        hoursValue:
          'सोमवार ते रविवार: सकाळी 9 ते संध्याकाळी 6 (रोज उघडं)'
      },
      success:
        'धन्यवाद! 24 तासांत फोन करू.',
      error:
        'पाठवता आलं नाही. कृपया फोन करा किंवा परत ट्राय करा.'
    },

    // FPC (Future)
    fpc: {
      title: 'शेतकरी उत्पादक कंपनी (एफपीसी)',
      comingSoon: 'लवकरच सुरू होतेय',
      description:
        'आम्ही शेतकरी उत्पादक कंपनी (एफपीसी) सुरू करतोय. एकत्र येऊन शेतकरी माल स्वस्तात घेऊ शकतील आणि चांगल्या भावाला विकू शकतील. कंपनीच्या नफ्यातही सगळ्यांचा हिस्सा असेल.',
      benefits: 'सदस्य शेतकऱ्यांना फायदे',
      benefit1: 'एकत्र विकल्याने चांगला भाव',
      benefit2: 'एकत्र घेतल्याने स्वस्त माल',
      benefit3: 'प्रोफेशनल मॅनेजमेंट, पारदर्शक व्यवहार',
      benefit4: 'कंपनीच्या नफ्यात तुमचा वाटा',
      register: 'नाव नोंदवा',
      registerDesc:
        'फाउंडर मेंबर व्हायचं? लवकर नोंदणी करा.'
    },

    // Export (Future)
    export: {
      title: 'एक्सपोर्ट सेवा',
      comingSoon: 'भविष्यातील योजना',
      description:
        'आंतरराष्ट्रीय मार्केटमध्ये उत्पादन एक्सपोर्ट करायला मदत करू—इंटरनॅशनल स्टँडर्ड पूर्ण करून आणि प्रीमियम रेट मिळवून.',
      features: 'आम्ही काय देणार',
      feature1: 'परदेशी खरेदीदारांशी कनेक्शन',
      feature2: 'एक्सपोर्ट पेपरवर्क आणि कंप्लायन्स',
      feature3: 'क्वॉलिटी सर्टिफिकेशन आणि ट्रॅकिंग',
      feature4: 'लॉजिस्टिक्स आणि सप्लाय चेन मदत'
    },

    // Mushroom Project (Marathi)
    mushroom: {
      badge: 'येणारा प्रकल्प',
      heroTitle: 'मशरूम उत्पादन युनिट',
      heroSubtitle: 'कन्हैया कृषी लवकरच व्यावसायिक ऑयस्टर मशरूम उत्पादन आणि प्रक्रिया युनिट सुरू करणार आहे — एक शाश्वत, उच्च-मूल्य कृषी व्यवसाय.',
      location: 'गट नं. ३७३, शेटफळ, ता. करमाळा, जि. सोलापूर, महाराष्ट्र',

      overviewTitle: 'प्रकल्पाबद्दल',
      overviewDesc: 'हे युनिट ताजे ऑयस्टर मशरूम आणि वाळलेले मशरूम, मशरूम पावडर असे मूल्यवर्धित उत्पादने तयार करेल. कच्चा माल म्हणून भात पेंढा, गव्हाचा काड वापरला जाईल — शाश्वत आणि कमी खर्चाचा व्यवसाय. महाराष्ट्र MAHADBT फलोत्पादन योजनेतून हा प्रकल्प साकारतोय.',

      stat1Label: 'पिशव्या प्रति सायकल',
      stat1Value: '१,५००',
      stat2Label: 'वार्षिक उत्पादन',
      stat2Value: '१८.२ टन',
      stat3Label: 'वार्षिक सायकल्स',
      stat3Value: '११',
      stat4Label: 'अपेक्षित वार्षिक उत्पन्न',
      stat4Value: '₹२२.९७ लाख',

      productsTitle: 'या युनिटमधील उत्पादने',
      productsSubtitle: 'तीन उत्पादन लाइन्स — ताजे, वाळलेले आणि पावडर — वेगवेगळ्या बाजारांसाठी.',
      prod1Title: 'ताजे ऑयस्टर मशरूम',
      prod1Desc: 'हॉटेल, रेस्टॉरंट, वसतिगृह आणि स्थानिक बाजारात पुरवठा. ताजे काढून त्याच दिवशी डिलिव्हरी.',
      prod1Price: 'घाऊक: ₹१००–१२०/किग्रा',
      prod2Title: 'वाळलेले मशरूम',
      prod2Desc: 'सौर किंवा ड्रम ड्रायरने वाळवले. दीर्घ शेल्फ लाइफ, रिटेल-रेडी पॅक — १००ग्रॅ, २५०ग्रॅ, ५००ग्रॅ.',
      prod2Price: 'किरकोळ: ₹८००–१,२००/किग्रा',
      prod3Title: 'मशरूम पावडर',
      prod3Desc: 'वाळलेल्या मशरूमपासून बारीक पावडर. स्वयंपाक, आरोग्य उत्पादने आणि पोषण पावडरमध्ये वापर.',
      prod3Price: 'किरकोळ: ₹४००–६००/किग्रा',

      whyTitle: 'ऑयस्टर मशरूम का?',
      why1: 'जलद वाढ — ३५–४० दिवसांत काढणी तयार',
      why2: 'महाराष्ट्राच्या हवामानात (२०–३०°C) उत्तम वाढते — AC नाही',
      why3: 'शेती कचऱ्यापासून तयार — कच्च्या मालाचा खर्च कमी',
      why4: 'मजबूत बाजार मागणी — भारतात वार्षिक १५–२०% वाढ',
      why5: 'अनेक उत्पन्न स्रोत — ताजे, वाळलेले, पावडर',
      why6: 'MAHADBT योजनेतून ४०% सरकारी अनुदान मिळण्यास पात्र',

      infraTitle: 'पायाभूत सुविधा',
      infraSubtitle: 'युनिटमध्ये संपूर्ण एकात्मिक उत्पादन सुविधा असेल.',
      infra1: 'मशरूम शेड (१,२००–१,४०० चौ.फूट)',
      infra2: 'इनक्युबेशन आणि फ्रुटिंग झोन',
      infra3: 'पास्च्युरायझेशन ड्रम आणि बॉयलर',
      infra4: 'ड्रम / सोलार ड्रायर',
      infra5: 'उत्पादन रॅक्स आणि साठवण',
      infra6: 'ऑफिस, टॉयलेट आणि युटिलिटीज',

      finTitle: 'आर्थिक ठळक मुद्दे',
      finCol1: 'तपशील',
      finCol2: 'रक्कम',
      fin1L: 'एकूण प्रकल्प खर्च',
      fin1V: '₹२९.८० लाख',
      fin2L: 'बँक टर्म लोन',
      fin2V: '₹१४.०० लाख',
      fin3L: 'MAHADBT अनुदान (४०%)',
      fin3V: '₹११.९२ लाख',
      fin4L: 'अपेक्षित वार्षिक उत्पन्न (वर्ष १)',
      fin4V: '₹२२.९७ लाख',
      fin5L: 'EBITDA (वर्ष १)',
      fin5V: '₹७.७४ लाख',
      fin6L: 'परतफेड कालावधी',
      fin6V: 'वर्ष १ च्या २–३ महिन्यांत',

      timelineTitle: 'प्रकल्प वेळापत्रक',
      timelineSubtitle: 'कर्ज वितरणापासून ८.५–१० महिन्यांत व्यावसायिक उत्पादन सुरू होण्याची अपेक्षा.',
      phase1: 'जागा तयारी',
      phase1Desc: 'जागा साफ करणे, परवानगी, विक्रेता निवड, डिझाइन अंतिम करणे.',
      phase1Months: 'महिना १–२',
      phase2: 'बांधकाम आणि उपकरणे',
      phase2Desc: 'शेड बांधकाम, वीज, पाणी फिटिंग, सर्व उपकरणे बसवणे.',
      phase2Months: 'महिना ३–७.५',
      phase3: 'व्यावसायिक उत्पादन',
      phase3Desc: 'चाचणी बॅच, पहिली कापणी, बाजार लाँच — पूर्ण उत्पादन सुरू.',
      phase3Months: 'महिना ८.५ पुढे',

      ctaTitle: 'खरेदी किंवा भागीदारीत रस आहे?',
      ctaDesc: 'हॉटेल, रेस्टॉरंट, रिटेलर किंवा डिस्ट्रिब्युटर असल्यास — पुरवठ्यासाठी आगाऊ नोंदणी करण्यासाठी संपर्क करा.',
      ctaBtn: 'संपर्क करा'
    },

    // Footer
    footer: {
      about: 'आमच्याबद्दल',
      aboutText:
        'जेऊर, करमाळा तालुका येथील कन्हैया कृषी सेवा केंद्र—सोलापूर जिल्ह्यातील शेतकऱ्यांसाठी संपूर्ण शेती सोल्यूशन.',
      quickLinks: 'लिंक्स',
      services: 'सेवा',
      contactUs: 'संपर्क',
      followUs: 'फॉलो करा',
      copyright:
        '© 2025 कन्हैया कृषी सेवा केंद्र. सर्व हक्क राखीव.',
      developedBy:
        'सोलापूर जिल्ह्यातील शेतकऱ्यांची अभिमानाने सेवा'
    },

    // Common
    common: {
      readMore: 'अधिक माहिती',
      close: 'बंद करा',
      submit: 'पाठवा',
      cancel: 'कॅन्सल करा',
      search: 'शोधा',
      filter: 'फिल्टर',
      sort: 'सॉर्ट करा',
      loading: 'लोड होतंय...',
      error: 'एरर आली',
      success: 'झालं!',
      required: 'आवश्यक'
    }
  }
};
